import { ICity } from "@/modules/user-location";
import { systemCountries } from "@/package/global-constants/system-countries";

export function getSystemCountry() {
  switch (window.location.hostname) {
    case import.meta.env.VITE_FRONT_KG:
      return "kg";
    case import.meta.env.VITE_FRONT_GH:
      return "gh";
    case import.meta.env.VITE_FRONT_MD:
      return "md";
    case import.meta.env.VITE_FRONT_KZ:
      return "kz";
    case import.meta.env.VITE_FRONT_UZ:
      return "uz";
    default:
      return "ru";
  }
}

export function getCurrentCountry() {
  return systemCountries.find((country) => country.id === getSystemCountry());
}

export function selectUserCity(city: ICity) {
  if (city.country !== getSystemCountry()) {
    switch (city.country) {
      case "kz":
        window.open(
          `https://${import.meta.env.VITE_FRONT_KZ}/?city=${city.id}`,
          "_self"
        );
        break;
      case "md":
        window.open(
          `https://${import.meta.env.VITE_FRONT_MD}/?city=${city.id}`,
          "_self"
        );
        break;
      default:
        window.open(
          `https://${import.meta.env.VITE_FRONT}/?city=${city.id}`,
          "_self"
        );
        break;
    }
    return;
  }

  localStorage.setItem("userCity", city.id.toString());
  window.location.reload();
}

export function getCurrentDomain() {
  switch (getSystemCountry()) {
    case "kg":
      return import.meta.env.VITE_KG_HOST;
    case "uz":
      return import.meta.env.VITE_UZ_HOST;
    default:
      return import.meta.env.VITE_HOST;
  }
}
